import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import Waiting from '../components/waiting';
import { querystring, buildQueryString } from '../utils/helpers';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { useStores } from '../hooks/use-stores';
import services from '../services';

function DirectSignIn() {
    const navigate = useNavigate();
    const { token } = useParams();
    const location = useLocation();
    const { authStore, store, companyStore } = useStores();
    const { contextParams } = store;

    useEffect(() => {
        if (!token) return;
        const companyId = querystring('o', location.pathname + location.search) || companyStore.companyId || localStorage.getItem('companyId');
        let redirect = querystring('redirect', location.pathname + location.search) || '/';
        if (!redirect.startsWith('/')) redirect = `/${redirect}`;
        if (redirect === '/') {
            redirect = `${redirect}?${buildQueryString(contextParams)}`;
        }

        // Old permanent_access_token links: resend sign-in email, then go to login and show "email was resent"
        services.Auth.resendLoginByPermanentToken(token, {
            companyId: companyId ? parseInt(companyId, 10) : undefined,
            redirect,
        })
            .then(() => {
                navigate(
                    `/auth/signin?emailResent=1&redirect=${encodeURIComponent(redirect)}`,
                    { replace: true }
                );
            })
            .catch(() => {
                navigate(`/auth/signin?redirect=${encodeURIComponent(redirect)}`, {
                    replace: true,
                });
            });
    }, [token, location.pathname, location.search, contextParams, navigate]);

    return <Waiting waitingActive={true} from="DirectSignIn" />;
}

export default observer(DirectSignIn);
